import ky, { HTTPError } from "ky-universal";
import debug from "../debug.js";
import { mapHeaders } from "./headers.js";
import { setPathParams } from "./path.js";
import { mapResponse } from "./response.js";
import { convertQueryToUrlSearchParams } from "./request.js";
import RequestError from "../RequestError.js";
import { patchedFetchForSafari } from "./safari.js";
const d = debug.extend("KyHTTPClient");
const defaultOptions = {
    defaultHeaders: {},
    requestOptionsHook: (opts) => opts,
    ky: {
        fetch: patchedFetchForSafari,
    },
};
export class KyClient {
    ky;
    options;
    constructor(options = {}) {
        this.options = {
            ...defaultOptions,
            ...options,
        };
        this.ky = ky.extend({
            ...defaultOptions.ky,
            ...(options.ky ?? {}),
        });
    }
    setDefaultHeaders(headers) {
        this.options.defaultHeaders = headers;
    }
    requestFunctionFactory = (descriptor) => async (request, requestOptions) => {
        const { path, method } = descriptor;
        const { header, requestBody, path: pathParams, query } = request ?? {};
        // make a shallow copy
        const options = this.options.requestOptionsHook({ ...this.options });
        const resolvedPath = setPathParams(path, pathParams);
        try {
            const kyRequestOptions = {
                method,
                headers: {
                    ...options.defaultHeaders,
                    ...mapHeaders(header),
                },
                searchParams: convertQueryToUrlSearchParams(query),
            };
            if (requestOptions?.timeout !== undefined) {
                kyRequestOptions.timeout = requestOptions.timeout;
            }
            if (requestBody) {
                kyRequestOptions.json = requestBody;
            }
            d("%s: starting %o request", resolvedPath, method.toUpperCase());
            const kyResponse = await this.ky(resolvedPath, kyRequestOptions);
            d("%s: request done. mapping response", resolvedPath);
            return (await mapResponse(kyResponse, descriptor));
        }
        catch (error) {
            if (error instanceof HTTPError) {
                d("request failed with ky HTTPError");
                return (await mapResponse(error.response, descriptor));
            }
            d("request failed");
            throw new RequestError(resolvedPath, descriptor.method, error);
        }
    };
}
//# sourceMappingURL=data:application/json;base64,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